import { Suspense, lazy } from 'react';

const UserDebugModal = lazy(
  () =>
    import(
      /* webpackChunkName: "UserDebugModal" */
      'modules/User/components/UserDebugModal/UserDebugModal'
    ),
);

type DebugModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

/**
 * An internal debug modal for standalone - should not be used in production/staging/prestaging
 */
export const DebugModal = ({ isOpen, onClose }: DebugModalProps) => {
  return (
    <Suspense fallback={null}>
      <UserDebugModal isOpen={isOpen} onClose={onClose} />
    </Suspense>
  );
};
